export interface ScoreIndicators {
  livingStandard: number;
  budgetManagement: number;
  financialEvolution: number;
}

export interface CreditScore {
  version: string;
  value: number;
  indicators?: ScoreIndicators;
}

export interface Scores {
  creditScore?: CreditScore;
}

export const minimumScoreValue = 0;
export const maximumScoreValue = 1000;
